import { Box, Text, Flex, Divider, Button, useDisclosure, Tooltip } from '@chakra-ui/react';
import { FormattedMessage, useIntl } from 'react-intl';
import { ReactComponent as HydroItemIcon } from '../../icons/item-icons/hydro-project.svg';
import styled from '@emotion/styled/macro';
import CustomNavLink from 'components/utils/CustomNavLink';
import ItemPropertiesModal from '../utils/ItemPropertiesModal';
import SecondaryIconButton from 'components/utils/SecondaryIconButton';
import { ReactComponent as FileIcon } from '../../icons/file.svg';
import ActionBar from 'components/utils/ActionBar';
import { HYDRO_PROJECT_ROUTES } from 'constants/routes';

const HydroProjectPortfolio = ({ portfolioItem, onNodeOwnershipPercentageUpdate }) => {
    const propertiesModal = useDisclosure();
    const intl = useIntl();
    return (
        <>
            {propertiesModal.isOpen && (
                <ItemPropertiesModal
                    isOpen
                    onClose={propertiesModal.onClose}
                    itemId={portfolioItem.id}
                    portfolio={portfolioItem}
                    onNodeOwnershipPercentageUpdate={onNodeOwnershipPercentageUpdate}
                    forAutoForm={true} // While this form is not technically an autoform, this value is used to determine the header text
                />
            )}

            <Flex flexDirection="column" h="100%" backgroundColor="background-secondary">
                <Flex alignItems="center" px={6} mt={7} mb={5}>
                    <StyledHydroItemIcon isMaster={portfolioItem.properties?.isMaster} />
                    <Text ml={3} color="gray.900" fontSize="2xl">
                        {portfolioItem.label}
                    </Text>
                </Flex>
                <ActionBar>
                    <Tooltip label={intl.formatMessage({ id: 'hydro_item_properties_tooltip' })}>
                        <SecondaryIconButton
                            leftIcon={<FileIcon />}
                            size="sm"
                            variant="secondary"
                            flexShrink={0}
                            onClick={propertiesModal.onOpen}
                        >
                            <FormattedMessage id="portfolio_item_properties" />
                        </SecondaryIconButton>
                    </Tooltip>
                </ActionBar>
                <Divider />
                <Box px={6}>
                    <Text mt={8} mb={4}>
                        <FormattedMessage id="hydro_project_configure_item" />
                    </Text>
                    <Button
                        as={CustomNavLink}
                        to={`/hydro-project/${HYDRO_PROJECT_ROUTES.PLANT_CONFIG}/${portfolioItem.properties?.id}`}
                        type="button"
                    >
                        <FormattedMessage id="common_configure" />
                    </Button>
                </Box>
            </Flex>
        </>
    );
};

const StyledHydroItemIcon = styled(HydroItemIcon, { shouldForwardProp: (prop) => prop !== 'isMaster' })`
    width: 32px;
    height: 32px;
    color: var(--chakra-colors-${(props) => (props.isMaster ? 'green-500' : 'gray-600')});
`;

export default HydroProjectPortfolio;
